import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/PlaceAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { fetchPlace, FetchPlacePayload, placeFetched, placeFetchFailed } from '../../actions/place/fetchPlace';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchPlaceSaga({ payload }: Action<FetchPlacePayload>) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { fetchState, placeUuid } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getPlace, token, { placeUuid });
  const { place, error } = response;
  if (!error) {
    const responsePayload = {
      place: fromDto(place),
      timestamp,
    };
    const responseAction = placeFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = placeFetchFailed({ timestamp, placeUuid });
    yield put(responseAction);
  }
}

export default function* watchFetchPlaceSaga() {
  yield takeEvery(fetchPlace, fetchPlaceSaga);
}
